var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1,32.8L40.5,11C38.9,9.5,37,8.7,35,8.7l0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-2,0-3.9,0.8-5.5,2.3L5.9,32.8 c-1.5,1.4-1.8,3.7-0.5,5.3l0,0c1.2,1.4,3.2,1.6,4.6,0.4l0.7-0.6v16.3c0,2.6,2,4.8,4.6,4.8H35h0h19.7c2.5,0,4.6-2.1,4.6-4.8V38 l0.7,0.6c1.5,1.1,3.5,1,4.6-0.4l0,0C66,36.5,65.7,34.2,64.1,32.8z M45.8,39.9l-9.9,9.7C35.7,49.9,35.3,50,35,50 c-0.3,0-0.7-0.2-0.9-0.4l-9.9-9.7c-1.3-1.3-2.2-3-2.1-5c0-3.6,2.9-6.5,6.5-6.7c1.9-0.1,3.7,0.6,5,1.9l0,0l1.5,1.4v0l0,0l0,0v0 l1.5-1.4l0,0c1.3-1.2,3.1-2,5-1.9c3.6,0.2,6.4,3.1,6.5,6.7C48,36.9,47.2,38.7,45.8,39.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1f82b9cfbceb75de8e6247d5a63a7787.svg";
export { ForwardRef as ReactComponent };